import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Modal from './Modal';
import * as Sentry from "@sentry/react";
import { Fallback } from './Fallback';

const Layout = () => {

  return (
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      <div className="flex flex-col w-full tracking-[-0.2px]">
        <Toaster />
        <Modal />
        <main className="max-w-screen-md mx-auto w-full flex flex-col">
          <Outlet />
        </main>
        {/* <footer className="py-4 bg-gray-50 border-t border-gray-200 mt-auto">
          <div className="container max-w-screen-md mx-auto px-4 text-center text-gray-500">
            <div className="flex justify-center space-x-4">
              <Link to="/privacy" className="hover:text-blue-600 transition-colors">
                개인정보처리방침
              </Link>
            </div>
            <p className="mt-2">© {new Date().getFullYear()} 부싯돌. 모든 권리 보유.</p>
          </div>
        </footer> */}
      </div>
    </Sentry.ErrorBoundary>
  );
};

export default Layout; 